import { useState } from 'react';

export function useImageGenerate() {
  const [selectedImage, setSelectedImage] = useState<File | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  function setImage(file: File | null) {
    if (file) {
      setSelectedImage(file);
      setPreviewUrl(URL.createObjectURL(file));
    } else {
      setSelectedImage(null);
      setPreviewUrl(null);
    }
  }

  function clearImage() {
    setSelectedImage(null);
    setPreviewUrl(null);
  }

  return {
    selectedImage,
    previewUrl,
    setImage,
    clearImage,
  };
}
